module.exports = __webpack_public_path__ + "img/icon_xdyl.24eddf92.png";